import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'hs-close-session-modal',
  templateUrl: './close-session-modal.component.html',
})
export class CloseSessionModalComponent {
  @Input() sessionId!: string
  @Input() hasReviewItems!: boolean

  constructor(public activeModal: NgbActiveModal) {}

  confirm() {
    this.activeModal.close(true)
  }

  cancel() {
    this.activeModal.dismiss(false)
  }
}
